// Global Instructions Rule Applied!

import {
  FilterValue,
  SortConfig,
  FundraisingTarget,
  SetFilterOptionsAction,
  SetFundraisingAction,
  SetActiveFiltersAction,
  SetActiveSortingAction,
  ClearActiveFiltersAction,
  UpdateProspectRecordAction,
  AddProspectAction,
  AppendFundraisingAction,
  SetPipelineSelectedFundAction,
  RemoveProspectFromListAction
} from '../../interfaces/fundraising.ts'
import { FundraisingPaginatedResponse } from '../../../app_modules/fundraising/services/fundraisingService.ts'
import { TableFilterOptionsResponse } from '../../rpc_models/get_table_filter_options_response.ts'
import { ProspectRecord } from '../../interfaces/fundraising.ts'
import {
  SET_FILTER_OPTIONS,
  SET_FUNDRAISING,
  SET_ACTIVE_FILTERS,
  SET_ACTIVE_SORTING,
  CLEAR_ACTIVE_FILTERS,
  UPDATE_PROSPECT_RECORD,
  ADD_PROSPECT,
  APPEND_FUNDRAISING,
  SET_PIPELINE_SELECTED_FUND,
  REMOVE_PROSPECT_FROM_LIST
} from './constants.ts'

export const setFilterOptions = ({ response }: { response: TableFilterOptionsResponse }): SetFilterOptionsAction => ({
  type: SET_FILTER_OPTIONS,
  payload: { response }
})

export const setFundraising = ({
  response,
  target
}: {
  response: FundraisingPaginatedResponse
  target?: FundraisingTarget
}): SetFundraisingAction => ({
  type: SET_FUNDRAISING,
  payload: { response, target }
})

export const setActiveFilters = ({ filters }: { filters: FilterValue[] }): SetActiveFiltersAction => ({
  type: SET_ACTIVE_FILTERS,
  payload: { filters }
})

export const setActiveSorting = ({ sorting }: { sorting: SortConfig[] }): SetActiveSortingAction => ({
  type: SET_ACTIVE_SORTING,
  payload: { sorting }
})

export const clearActiveFilters = (): ClearActiveFiltersAction => ({
  type: CLEAR_ACTIVE_FILTERS,
  payload: {}
})

export const updateProspectRecord = ({
  prospectId,
  updates
}: {
  prospectId: string
  updates: Record<string, any>
}): UpdateProspectRecordAction => ({
  type: UPDATE_PROSPECT_RECORD,
  payload: { prospectId, updates }
})

export const addProspect = ({ prospect }: { prospect: ProspectRecord }): AddProspectAction => ({
  type: ADD_PROSPECT,
  payload: { prospect }
})

export const appendFundraising = ({
  response
}: {
  response: FundraisingPaginatedResponse
}): AppendFundraisingAction => ({
  type: APPEND_FUNDRAISING,
  payload: { response }
})

export const setPipelineSelectedFund = ({
  selectedFundId
}: {
  selectedFundId: string | null
}): SetPipelineSelectedFundAction => ({
  type: SET_PIPELINE_SELECTED_FUND,
  payload: { selectedFundId }
})

export const removeProspectFromList = ({
  prospectId
}: {
  prospectId: string
}): RemoveProspectFromListAction => ({
  type: REMOVE_PROSPECT_FROM_LIST,
  payload: { prospectId }
})
